/**
 * smsMetin.js — an SMS text as the vendor counts and accepts it (backlog #637; the same rules as FDS-Backend `VatanSmsText`, #632 / #634).
 *
 * Pure, no network. The editor counter and the announcement composer (#643) show what the vendor will bill; the BACKEND stays the judge (it refuses a
 * text with a character outside the vendor's table at save and at send), this only tells staff before they press Save.
 *   · a line break is one character; some characters count TWICE (new line, € { } [ ~ ] ^ | and ç ş ğ ı Ş İ Ğ)
 *   · one part holds 160 counted characters (153 per part when there are several); a text with a Turkish letter is sent with tur=Turkce and holds 155 / 149
 *   · a message may count at most 918; an OTP text is limited to 160 INCLUDING the code the operator appends, so the own text should stay near 150
 *   · only A-Z a-z 0-9 space . , and the vendor's table go through; a double quote, a backslash, [ ] |, a back tick and anything not Latin (é, emoji...) do NOT
 */
export const SMS_MAX = 918;
/** The OTP channel: the whole message, with the vendor's code, is one part of 160. */
export const OTP_SINIRI = 160;
/** The advised length of the own text of an OTP template (the operator adds its own code). */
export const OTP_ONERILEN = 150;

const TABLO = "@£$€_!'#%&()*+-/:;<=>?{}~^öüçşğıÖÜÇŞİĞ\n";
const IKI_SAYILAN = new Set(['\r', '\n', '€', '{', '}', '[', '~', ']', '^', '|', 'ç', 'ş', 'ğ', 'ı', 'Ş', 'İ', 'Ğ']);
const TURKCE_HARFLER = 'çğışöüÇĞİŞÖÜ';

export const duzelt = (metin) => (metin == null ? '' : String(metin).replace(/\r\n/g, '\n').replace(/\r/g, '\n'));

const duz = (ch) => /^[A-Za-z0-9 .,]$/.test(ch);

/** Karakter karakter: { length, weighted, ekstra, turkce, parts, tooLong, otpAsti, desteklenmeyen[] } */
export function olc(metin) {
  const t = duzelt(metin);
  let weighted = 0;
  const desteklenmeyen = [];
  for (const ch of Array.from(t)) {
    weighted += IKI_SAYILAN.has(ch) ? 2 : (ch.length > 1 ? 2 : 1);
    if (!duz(ch) && !TABLO.includes(ch) && !desteklenmeyen.includes(ch)) desteklenmeyen.push(ch);
  }
  const turkce = Array.from(t).some((ch) => TURKCE_HARFLER.includes(ch));
  const ilk = turkce ? 155 : 160;
  const sonraki = turkce ? 149 : 153;
  const parts = weighted === 0 ? 0 : weighted <= ilk ? 1 : Math.ceil(weighted / sonraki);
  return {
    length: t.length, weighted, ekstra: weighted - t.length, turkce, parts, ilk, sonraki,
    tooLong: weighted > SMS_MAX, otpAsti: weighted > OTP_SINIRI, desteklenmeyen,
  };
}

const YER_TUTUCU = /\{\{\s*([A-Za-z][A-Za-z0-9_]*)\s*\}\}/g;

/** `{{AD}}` biçimindeki yer tutucuların adları (benzersiz, yazıldığı sırayla; e-posta şablonlarıyla aynı yazım). */
export function yerTutucular(metin) {
  const out = [];
  for (const m of String(metin || "").matchAll(YER_TUTUCU)) if (!out.includes(m[1])) out.push(m[1]);
  return out;
}

/**
 * Yer tutucuları örnek değerleriyle doldurur (ör. { KOD: "123456", LINK: "https://..." }): sayaç şablonun HAM halini değil, gönderilecek metnin uzunluğunu
 * saysın diye. Örneği olmayan yer tutucu olduğu gibi kalır.
 */
export function doldur(metin, ornekler) {
  return String(metin || "").replace(YER_TUTUCU, (tam, ad) => (ornekler && ornekler[ad] !== undefined ? String(ornekler[ad]) : tam));
}
